import React from "react";
import FormSelect from "../FormSelect";

export const MasterAccountStatuses = {
    ActiveEnquiry: { label: 'Active Enquiry', value: 0 },
    ExpiredEnquiry: { label: 'Expired Enquiry', value: 1 },
    ActiveClient: { label: 'Active Client', value: 2 },
    NewIFA: { label: 'New IFA', value: 3 },
    Deceased: { label: 'Deceased', value: 4 },
    ExClient: { label: 'Ex-Client', value: 5 },
    Disposed: { label: 'Disposed', value: 6 },
    NoOngoingService: { label: 'No Ongoing Service', value: 7 }
};

const MasterAccountStatusSelect = ({ options, ...rest }) => {
    return <FormSelect
        options={Object.values(MasterAccountStatuses)}
        {...rest}
    />
};

export default MasterAccountStatusSelect;